import $ from 'jquery'
import {connect} from "../redux/utils"
import {bindActionCreators} from "redux"
import {setCpPanelMaxWidth} from './customersProjectsPanel/actions'
import WindowSizeDependedView from '../WindowSizeDependedView'

class TaskManagementPage extends WindowSizeDependedView {
    constructor({
        setCpPanelMaxWidth = () => {},
    }) {
        super()

        this.actions = {
            setCpPanelMaxWidth,
        }

    }

    templateHtml() {
        return "<div id='taskManagementPage'>" +
               "  <div class='cpTreeBlock ui-widget-content'></div>" +
               "  <div class='taskListBlockWrapper'>" +
               "     <div id='taskListBlock'></div>" +
               "  </div>" +
               "</div>"
    }

    adjustSize()
    {
        super.adjustSize();
        this.actions.setCpPanelMaxWidth($(window).width())
    }
}

export default connect(
    state => ({}),
    dispatch => ({
        setCpPanelMaxWidth: bindActionCreators(setCpPanelMaxWidth, dispatch),
    })
)(TaskManagementPage)


// WEBPACK FOOTER //
// ./web/js/taskManagement/Page.js